import React from 'react'
import PropTypes from 'prop-types'

const Title = React.memo(({ image, title, doubleIcon, children }) => {
  console.log('n Title', image, title)

  return (
    <div className="section-title wow fadeInUp">
      <h2>
        <img src={`${image}`} alt="" />
        {` ${title}`}
        {doubleIcon && <img src={`${process.env.REACT_APP_BASE_URL}/${image}`} alt="" style={{ margin: '0 0 0 10px' }} />}
      </h2>
      {children}
    </div>
  )
});

Title.propTypes = {
  title: PropTypes.string,
  image: PropTypes.string,
  doubleIcon: PropTypes.bool,
}

Title.defaultProps = {
  title: 'Our services',
  image: '/resources/img/sabinehospital-icons/sabinehospital-heartbeat.svg',
  doubleIcon: false,
}

export default Title
